// The Wi-Fi a device is ACTUALLY joined to — its SSID and, for those allowed,
// the password — for the Device Details / Device Info sheets in both shells.
//
// ⚠️ ONLY `GetDeviceInstalledDetailsbyDevicesInstalledId` carries them: it is
// `select a.*`, so it has `WifiName` (written by the FIRMWARE on every status
// update) and `WifiPassword`. `GetDeviceDetailbyUniqueNumber` names its columns
// and has neither. It takes the INSTALLED id, so a device opened from a list
// (no `ID`) is resolved by unique number first.
//
// ⚠️ THE PASSWORD IS A SECRET OF THE SITE. Same rule as a location's saved
// networks (useLocationChoices): a Super Admin, or the device's OWNER
// (DevicesInstalled.MasterUserId). Anyone else — a guest mapped to one room —
// gets the name only; the password is not even returned to the screen, so it
// never sits in React state, a log or a crash report.

import { getDeviceDetail, getDeviceInstalledById } from '../api/api';
import { firmwareStateOf } from './firmwareInfo';

// The same row also carries the update facts every details sheet shows —
// CodeUpdated (last code update), RequireUpdateCode and PendingCommand (marked
// for update) — so they come back from this one call as `update`.
const NO_UPDATE = { flashedAt: null, updateMarked: false, pendingCommand: '' };

/** May this user see this device's Wi-Fi password? */
export const canSeeWifiPassword = (row, { isSuperAdmin, userId }) =>
  !!isSuperAdmin || (Number(userId) > 0 && Number(row && row.MasterUserId) === Number(userId));

/**
 * -> { name, password, update } — password is null unless allowed (or unknown);
 * update = { flashedAt, updateMarked, pendingCommand }.
 * Never throws; empty values when it cannot be resolved.
 */
export async function getDeviceWifi(device, who) {
  try {
    let installedId = device && device.ID;
    if (installedId == null) {
      const res = await getDeviceDetail(device && device.UniqueNumber);
      installedId = (Array.isArray(res.data) ? res.data[0] : null)?.ID;
    }
    if (installedId == null) return { name: null, password: null, update: NO_UPDATE };
    const res = await getDeviceInstalledById(installedId);
    const row = Array.isArray(res.data) ? res.data[0] : null;
    if (!row) return { name: null, password: null, update: NO_UPDATE };
    return {
      name: row.WifiName || null,
      password: canSeeWifiPassword(row, who) ? (row.WifiPassword || null) : null,
      update: (({ flashedAt, updateMarked, pendingCommand }) => ({ flashedAt, updateMarked, pendingCommand }))(firmwareStateOf(row)),
    };
  } catch (e) {
    return { name: null, password: null, update: NO_UPDATE };
  }
}
